/**
* 左边菜单 
* element ui 使用:index 进行路由跳转
*/ 
<template>
	<!-- :default-active="$route.path"  下面标签中报错属性 el-menu-->
	<!-- 主菜单 -->
	<el-menu default-active="2" :collapse="collapsed" collapse-transition router unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
		<div class="logobox">
			<!-- <img class="logoimg" src="../assets/img/comLogo.png" alt=""> -->
			<span style="font-size: 15px;">水污染源在线监测系统</span>
		</div>
		<!-- 下级菜单可能是二级或者三级四级五级 -->
		<template v-for="menu in allmenu">
			<el-submenu :key="menu.menuid" v-if="isShow(menu.isAdmin)" :index="menu.menuname">
				<template slot="title">
					<i class="iconfont" :class="menu.icon"></i>
					<span>{{menu.menuname}}</span>
				</template>
				<el-menu-item-group>
					<!-- v-if 和 v-for 不能同时使用  用template在外面套一层 -->
					<template v-for="chmenu in menu.menus">
						<!-- 展示最终菜单 -->
						<el-menu-item v-if="chmenu.hasThird!=null" :index="'/'+chmenu.url" :key="chmenu.menuid">
							<i class="iconfont" :class="chmenu.icon"></i>
							<span>{{chmenu.menuname}}</span>
						</el-menu-item>
						<!-- 如果有下级菜单展示父级菜单 -->
						<el-submenu v-else :index="'/'+chmenu.url" :key="'sub_'+chmenu.menuid">
							<template slot="title">
								<i class="iconfont" :class="menu.icon"></i>
								<span>{{menu.menuname}}</span>
							</template>
							<!-- 每组选项卡需要group分组 -->
							<el-menu-item-group>
								<template v-for="chmenus in chmenu.menus">
									<!-- 展示选项卡 -->
									<el-menu-item v-if="chmenus.hasThird!=null" :index="'/'+chmenus.url" :key="chmenus.menuid">
										<i class="iconfont" :class="chmenus.icon"></i>
										<span>{{chmenus.menuname}}</span>
									</el-menu-item>
								</template>
							</el-menu-item-group>
						</el-submenu>
					</template>

				</el-menu-item-group>

			</el-submenu>
		</template>

	</el-menu>
</template>
<script>
import { menu } from '../api/userMG';
export default {
	name: 'leftnav',
	data() {
		return {
			collapsed: false,
			allmenu: [],
		};
	},
	computed: {},
	methods: {
		isShow(param) {
			if (param) {
				const user=JSON.parse(localStorage.getItem('userdata'));
				return user.id===2;
			}
			return true;
		},
	},
	// 创建完毕状态(里面是操作)
	created() {
		// 获取图形验证码
		let res = {
			success: true,
			data: [
				// {
				// 	menuid: 1,
				// 	icon: 'li-icon-xiangmuguanli',
				// 	menuname: '基础管理',
				// 	hasThird: null,
				// 	url: null,
				// 	menus: [
				// 		{
				// 			menuid: 2,
				// 			icon: 'icon-cat-skuQuery',
				// 			menuname: '商品管理',
				// 			hasThird: 'N',
				// 			url: 'goods/Goods',
				// 			menus: null,
				// 		},
				// 		{
				// 			menuid: 3,
				// 			icon: 'icon-cat-skuQuery',
				// 			menuname: '测试管理',
				// 			hasThird: null,
				// 			url: null,
				// 			menus: [
				// 				{
				// 					menuid: 31,
				// 					icon: 'icon-cat-skuQuery',
				// 					menuname: '测试管理1',
				// 					hasThird: 'N',
				// 					url: 'goods/Goods',
				// 					menus: null,
				// 				},{
				// 					menuid: 32,
				// 					icon: 'icon-cat-skuQuery',
				// 					menuname: '测试管理2',
				// 					hasThird: 'N',
				// 					url: 'goods/Goods',
				// 					menus: null,
				// 				},
				// 			],
				// 		},
				// 	],
				// },
				{
					menuid: 33,
					icon: 'li-icon-dingdanguanli',
					menuname: '智能监控',
					hasThird: null,
					url: null,
					menus: [
						// {
						// 	menuid: 334,
						// 	icon: 'icon-order-manage',
						// 	menuname: '交易订单',
						// 	hasThird: 'N',
						// 	url: 'pay/Order',
						// 	menus: null,
						// },
						{
							menuid: 335,
							icon: 'icon-order-manage',
							menuname: '检测数据',
							hasThird: 'N',
							url: 'pay/Data',
							menus: null,
						},
						{
							menuid: 336,
							icon: 'icon-order-manage',
							menuname: '异常数据',
							hasThird: 'N',
							url: 'pay/ErrorData',
							menus: null,
						},
						{
							menuid: 337,
							icon: 'icon-order-manage',
							menuname: '电表数据',
							hasThird: 'N',
							url: 'pay/PowerData',
							menus: null,
						},
						{
							menuid: 338,
							icon: 'icon-order-manage',
							menuname: '流量数据',
							hasThird: 'N',
							url: 'pay/WaterData',
							menus: null,
						},
					],
				},
				{
					menuid: 71,
					icon: 'li-icon-xitongguanli',
					menuname: '系统管理',
					hasThird: null,
					isAdmin: true,
					url: null,
					menus: [
						{
							menuid: 72,
							icon: 'icon-cus-manage',
							menuname: '用户管理',
							hasThird: 'N',
							url: 'system/user',
							menus: null,
						},
						{
							menuid: 174,
							icon: 'icon-cms-manage',
							menuname: '控制台',
							hasThird: 'N',
							url: 'system/console',
							menus: null,
						},
						// {
						// 	menuid: 174,
						// 	icon: 'icon-cms-manage',
						// 	menuname: '菜单管理',
						// 	hasThird: 'N',
						// 	url: 'system/Module',
						// 	menus: null,
						// },
						// {
						// 	menuid: 73,
						// 	icon: 'icon-news-manage',
						// 	menuname: '角色管理',
						// 	hasThird: 'N',
						// 	url: 'system/Role',
						// 	menus: null,
						// },
						{
							menuid: 74,
							icon: 'icon-cs-manage',
							menuname: '公司管理',
							hasThird: 'N',
							url: 'system/Dept',
							menus: null,
						},
						// {
						// 	menuid: 75,
						// 	icon: 'icon-promotion-manage',
						// 	menuname: '系统环境变量',
						// 	hasThird: 'N',
						// 	url: 'system/Variable',
						// 	menus: null,
						// },
						// {
						// 	menuid: 76,
						// 	icon: 'icon-cms-manage',
						// 	menuname: '权限管理',
						// 	hasThird: 'N',
						// 	url: 'system/Permission',
						// 	menus: null,
						// },
					],
				},
				// {
				// 	menuid: 128,
				// 	icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
				// 	menuname: '支付管理',
				// 	hasThird: null,
				// 	url: null,
				// 	menus: [
				// 		{
				// 			menuid: 129,
				// 			icon: 'icon-provider-manage',
				// 			menuname: '支付配置信息',
				// 			hasThird: 'N',
				// 			url: 'machine/MachineConfig',
				// 			menus: null,
				// 		},
				// 		{
				// 			menuid: 175,
				// 			icon: 'icon-provider-manage',
				// 			menuname: '支付配置',
				// 			hasThird: 'N',
				// 			url: 'pay/Config',
				// 			menus: null,
				// 		},
				// 	],
				// },
				// {
				// 	menuid: 150,
				// 	icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
				// 	menuname: '图表',
				// 	hasThird: null,
				// 	url: null,
				// 	menus: [
				// 		{
				// 			menuid: 159,
				// 			icon: 'icon-provider-manage',
				// 			menuname: '数据可视化',
				// 			hasThird: 'N',
				// 			url: 'charts/statistics',
				// 			menus: null,
				// 		},
				// 	],
				// },
			],
			msg: 'success',
		};
		this.allmenu = res.data;

		// menu(localStorage.getItem('logintoken'))
		//   .then(res => {
		//     console.log(JSON.stringify(res))
		//     if (res.success) {
		//       this.allmenu = res.data
		//     } else {
		//       this.$message.error(res.msg)
		//       return false
		//     }
		//   })
		//   .catch(err => {
		//     this.$message.error('菜单加载失败，请稍后再试！')
		//   })
		// 监听
		this.$root.Bus.$on('toggle', (value) => {
			this.collapsed = !value;
		});
	},
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 240px;
	min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
	border: none;
	text-align: left;
}
.el-menu-item-group__title {
	padding: 0px;
}
.el-menu-bg {
	background-color: #1f2d3d !important;
}
.el-menu {
	border: none;
}
.logobox {
	height: 40px;
	line-height: 40px;
	color: #9d9d9d;
	font-size: 20px;
	text-align: center;
	padding: 20px 0px;
}
.logoimg {
	height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue